<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>supervised_user_circle</mat-icon>
        <div>GN1 Original</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

        <!--
          <input id='selectedFile' style="display: none;" #file type="file" accept='*/pdf'
            (change)="readCSVFile($event)" />
          <a mat-button style='width:60px;' onclick="document.getElementById('selectedFile').click();">
            <mat-icon class='icon-add'>cloud_upload</mat-icon>
          </a>
        -->

      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card id='table-body'>


    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortDisableClear=false>

      <!-- (matSortChange)="sortData($event)"-->

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Categoria </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.category }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="contacts">
        <mat-header-cell *matHeaderCellDef> E-mail/Celular </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="two-lines">
            <div>
              {{ element.email }}
            </div>
            <div>
              {{ element.cellPhone }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="docs">
        <mat-header-cell *matHeaderCellDef> CPF/CRM </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="two-lines">
            <div>
              {{ element.cpf }}
            </div>
            <div>
              {{ element.crm }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dates">
        <mat-header-cell *matHeaderCellDef> Nasc/Filiação </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="two-lines">
            <div>
              {{ element.birthDate }}
            </div>
            <div>
              {{ element.filiationDate }}
            </div>
          </div>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;" ></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>